interface Assets {
  includes: {
    Asset: Asset[]
  }
}

export const getAssetData = (id?: string, data?: Assets) => data?.includes.Asset?.find((item) => item.sys.id === id)
